import React from "react";
import { PRIMARY_COLOR } from "../../../constants";
import { Box, Tabs } from "@mui/material";

const Tab = ({
  title,
  isFocused,
  onClick,
}: {
  title: string;
  isFocused: boolean;
  onClick: any;
}) => {
  return (
    <p
      style={{
        color: isFocused ? PRIMARY_COLOR : '#666',
        borderColor: isFocused ? PRIMARY_COLOR : "#fff",
      }}
      onClick={onClick}
      className="flex-1 text-center cursor-pointer border-b-2 border-black p-4"
    >
      {title}
    </p>
  );
};

export default function FilterTab({
  value,
  handleChange,
}: {
  value: number;
  handleChange: any;
}) {
  return (
    <Box bgcolor={'white'}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="basic tabs example"
      >
        <Tab title="Active Service Status" isFocused={value===0} onClick={() => handleChange(0)} />
        <Tab title="Closed Service Status" isFocused={value===1} onClick={() => handleChange(1)} />
      </Tabs>
    </Box>
  );
}
